import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const BreadcrumbMeta: ComponentMeta = {
  componentName: "Breadcrumb",
  package: "@mijadesign/web",
  title: "面包屑",
  description: "显示当前页面在系统层级中的位置",
  category: ComponentCategory.NAVIGATION,
  icon: "ApartmentOutlined",
  visibleInComponentPanel: true,
  canHaveChildren: false,
  props: [
    {
      name: "items",
      label: "面包屑项",
      type: PropType.BREADCRUMB_ITEMS,
      defaultValue: [
        { title: "首页", href: "/" },
        { title: "应用中心", path: "/apps" },
        { title: "详情页" },
      ],
      group: "数据",
    },
    {
      name: "separator",
      label: "分隔符",
      type: PropType.STRING,
      defaultValue: "/",
      group: "样式",
    },
  ],
  defaultProps: {
    items: [
      { title: "首页", href: "/" },
      { title: "应用中心", path: "/apps" },
      { title: "详情页" },
    ],
    separator: "/",
  },
  preview: [
    {
      title: "默认层级",
      props: {
        items: [
          { title: "首页", href: "/" },
          { title: "应用中心", path: "/apps" },
          { title: "详情页" },
        ],
      },
    },
    {
      title: "自定义分隔符",
      props: {
        separator: ">",
        items: [
          { title: "控制台" },
          { title: "项目管理" },
          { title: "页面详情" },
        ],
      },
    },
  ],
  docLinks: [
    {
      title: "Breadcrumb 文档",
      url: "https://5x-ant-design.antgroup.com/components/breadcrumb-cn",
      source: "antd",
    },
  ],
  npm: {
    package: "antd",
    exportName: "Breadcrumb",
  },
  snippet: {
    componentName: "Breadcrumb",
    package: "antd",
    props: {
      items: [
        { title: "首页", href: "/" },
        { title: "应用中心", path: "/apps" },
        { title: "详情页" },
      ],
      separator: "/",
    },
  },
};
